const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabasePublishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY

export const runtimeConfig = {
  isDevelopment: import.meta.env.DEV,
  hasSupabaseConfig: Boolean(supabaseUrl && supabasePublishableKey),
  hasPosthogConfig: Boolean(import.meta.env.VITE_POSTHOG_KEY),
  supabaseUrl: supabaseUrl || null,
  supabasePublishableKey: supabasePublishableKey || null,
}

export const isDevBypassMode = false
export const shouldBypassSupabaseRequests = false
